import { PropsWithChildren } from 'react';

import { Balloons } from '../Icons';

import styles from './Error.module.scss';

export const Error = ({ children }: PropsWithChildren<object>) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Balloons size={250} />
        <br />
        {children}
      </div>
    </div>
  );
};
